/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { CostCenterFilterDto, CostCenterFinderListItemDto } from '@gh/builder-shared-data';

export type CostCenterFinderListItem = CostCenterFinderListItemDto;
export type CostCenterFinderFilter = CostCenterFilterDto;

export const getCostCenterFinderListItemId = ({ id }: CostCenterFinderListItem) => id;
